"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mean_1 = __importDefault(require("./mean"));
exports.default = (function (data) {
    var dataMean = mean_1.default(data);
    var sqDiff = data.map(function (n) { return Math.pow(n - dataMean, 2); });
    var avgSqDiff = mean_1.default(sqDiff);
    return Math.sqrt(avgSqDiff);
});
//# sourceMappingURL=stdev.js.map